export enum IdpOauth2LoginResponseType {
    CODE = 'code'
}
